module.exports = __webpack_public_path__ + "static/comverse-c7e496973fdbc06e1c8e9b2b565f4e7b.svg";